{
    "Profile_Dwellings_Garage.garage": "Garage",
    "Profile_Dwellings_Garage.garageDetails": "Garage Details",
    "Profile_Dwellings_Garage.type": "Type",
    "Profile_Dwellings_Garage.numberOfCars": "Number of Cars"
}
